export const LocationDocumentation = {
  general_settings: `
    <h5><b>Location Details</b></h5>
    <ul>
      <li><p><b>Location/Business Name</b>: The name of the location.</p></li>
      <li><p><b>Industry</b>: Select which industry the location will belong to from a drop-down list.</p></li>
      <li><p><b>Location Address</b>: The physical address of the location.</p></li>
    </ul>
    <br>
    <h5><b>Service Area</b></h5>
    <p>When a location is utilizing our texting/chat features, we provide the ability for a location to set a service area (a geographic area in which they are willing to service customers).</p>
    <ul>
      <li><p><b>Ideal Service Area</b>: The number of miles (from the <b>location address</b>) that they ideally would like to service.</p></li>
      <li><p><b>Max Service Area</b>: The maximum number of miles (from the <b>location address</b>) that they are willing to service customers.</p></li>
    </ul>
    <p>Within Message Center, there will be green/yellow/red indicators to show the potential client’s distance from the <b>location address</b>.</p>
  `,
  message_center: `
  <h5><b>Company Profile</b></h5>
  <p>A place to enter notes about the company that are visible to the agent in Message Center. This can be anything you want the agent to know about the location.</p>
  <br>
  <h5><b>Qualifying Lead Details</b></h5>
  <p>A place to enter notes about what determines a qualifying lead. This appears in Message Center and will help the agent determine what questions to ask, or what characteristics make a qualified lead.</p>
  <br>
  <h5><b>Set Location Hours</b></h5>
  <p>Configure the hours that the location is open for business. This will be used to determine when the system will push notifications or messages.</p>
  `,
  campaign_notifications: `
  <h5><b>Missed Calls</b></h5>
  <p>Toggle on whether or not you’d like to receive notifications for Missed Calls which have more than 2 rings (6 seconds). Calls routed to a SIP endpoint will not receive notifications.</p>
  <br>
  <h5><b>Voicemails</b></h5>
  <p>Toggle on whether or not you’d like to receive notifications for voicemails recieved.</p>
  <br>
  <h5><b>E-mail Notification Recipients</b></h5>
  <p>E-mail addresses of the people who would like to receive the notifications.</p>
  `,
  call_processing: `
  <h4><b>Leadscore Setup</b></h4>
  <p>LeadScore minimum duration is the lowest duration a call should have before being sent to LeadScore. If “30 seconds” is selected, only calls greater than 30 seconds will be sent to LeadScore for processing.</p>
  <br>
  <h4><b>DealSaver Setup</b></h4>
  <h5><b>DealSaver Category Toggles</b></h5>
  <p>Turn these toggles on if you’d like to have calls processed in DealSaver for any of those categories. Once turned on, any calls scored as that category in LeadScore will be sent to DealSaver processing. (i.e if Sales is toggled on, sales calls get sent to DealSaver).</p>
  <br>
  <h5><b>Email Notification Recipients</b></h5>
  <p>When a section is toggled on, an email address must be provided for the DealSaver Alerts. Enter in the email address of the person who should receive email alerts for calls marked ‘missed opportunity’ in DealSaver.</p>
  `,
  company_integrations: `
  
  `,
  callshield: `
  <h5><b>Custom CallShield Prompt</b></h5>
  <p>This is a static IVR with only two options: 1 or 2. Please create a prompt that instructs your consumer to either press 1 or press 2.</p>
  <br>
  <h5><b>Always Enable CallShield Prompt</b></h5>
  <p>When CallShield is set to On, the consumer will always be asked to press 1 or 2 on phone calls to your campaigns.</p>
  `,

  chatsettings: `
  <h5><b>Web Chat</b></h5>
  <p>Chat allows you to speak to your clients in realtime from one easy-to-use platform, ensuring that you never miss an opportunity to speak to a potential customer. Chats are easily managed in Message Center, where you can also access incoming text messages, making one convenient platform for agents to manage incoming leads</p>
  `
}